import { useState } from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";
import { ComplementsModal } from "../../Information/components/ComplementsModal";
import { useTranslation } from "react-i18next";
import {
  parseDateToLgComun,
  validInitDates,
} from "../../../../../helpers/dateTransform";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";

export const DetailsClosed = ({
  reportDetail,
  setEditClosed,
  setShowInput,
}) => {
  const [t] = useTranslation("report");
  const theme = useTheme();
  const [showComplementsModal, setShowComplementsModal] = useState(false);

  const handleEdit = () => {
    setEditClosed(true);
    setShowInput("closeReport");
  };


  console.log("Tenant",  localStorage.getItem("Tenant") );

  let kindOfClosedOptions;

  if( localStorage.getItem("Tenant") == '"odoo_wwwlineaeticalive"' ){
    // Status report type
    kindOfClosedOptions = [
      {
        label: "Cerrada Veraz",
        value: "founded",
      },
      {
        label: "Cerrada no Veraz ",
        value: "unfounded",
      },
      // {
      //   label: "Cerrada por falta de información/elementos",
      //   value: "inadmissible" },
      {
        label: "Cerrada por otros motivos",
        value: "undefined",
      },
    ];


  } else {

    // Status report type
    kindOfClosedOptions = [
      {
        label: t("Conclusion.closed_founded"),
        value: "founded",
      },
      {
        label: t("Conclusion.closed_unfounded"),
        value: "unfounded",
      },
      //{ label: t("Conclusion.inadmissible_report"), value: "inadmissible" },
      {
        label: t("Conclusion.closed_undetermined"),
        value: "undefined",
      },
    ];

  }

  // Opciones para el motivo de desestimación
  const undeterminedReasonOptions = {
    loss_of_object: t("Conclusion.undetermined_loss_of_object"),
    other_area: t("Conclusion.undetermined_other_area"),
    post_mortem: t("Conclusion.undetermined_post_mortem"),
  };

  return (
    <>
      <ComplementsModal
        show={showComplementsModal}
        onHide={() => setShowComplementsModal(false)}
        complements={reportDetail?.status?.details?.files || []}
      />
      <Box
        bgcolor={theme.palette.red.main}
        paddingY={0.9}
        paddingLeft={2}
        borderRadius="5px 5px 0px 0px"
      >
        <Typography color="white" fontSize={16} fontWeight={600}>
          {kindOfClosedOptions.find(
            (item) => item.value === reportDetail?.status?.details?.closed
          )?.label || "Sin especificar"}
        </Typography>
      </Box>
      <Box
        padding={1.8}
        paddingTop={2}
        border={`2px solid ${theme.palette.red.main}`}
        borderTop="none"
        borderRadius="0px 0px 5px 5px"
      >
        <Stack
          direction="row"
          alignItems="center"
          width="100%"
          marginBottom={1.4}
        >
          <Stack direction="row" alignItems="center" width="100%">
            <Icon
              name="calendar_circle_bold"
              size={20}
              color={theme.palette.red.main}
              style={{ marginRight: 10 }}
            />
            <Typography
              fontSize={16}
              fontWeight={600}
              color="secondary"
              marginRight={0.3}
            >
              {t("Conclusion.close_date")}:
            </Typography>

            <Typography color="error" fontWeight={700}>
              {validInitDates(reportDetail?.status?.details?.close_date)
                ? parseDateToLgComun(reportDetail?.status?.details?.close_date)
                : ""}
            </Typography>
          </Stack>
          <EGIconButton
            iconName="outline_edit"
            onClick={handleEdit}
            iconColor="primary"
            title={t("Conclusion.edit")}
          />
        </Stack>

        {/* Motivo de desestimación */}
        {reportDetail?.status?.details?.closed === "undefined" &&
          reportDetail?.status?.details?.undetermined_reason && (
          <Stack direction="row" alignItems="center" marginBottom={1.4}>
            <Icon
              name="bold_info_circle"
              size={20}
              color={theme.palette.orange.main}
              style={{ marginRight: 10 }}
            />
            <Typography
              fontSize={16}
              fontWeight={600}
              color="secondary"
              marginRight={0.3}
            >
              {t("Conclusion.undetermined_reason")}:
            </Typography>
            <Typography color="orange.main" fontWeight={700}>
              {undeterminedReasonOptions[reportDetail.status.details.undetermined_reason] ||
                reportDetail.status.details.undetermined_reason}
            </Typography>
          </Stack>
        )}

        {reportDetail?.status?.details?.followup && (
          <Stack direction="row" alignItems="center" marginBottom={2}>
            <Box marginRight={1}>
              <Icon
                name="bold_routing_2"
                size={24}
                color={theme.palette.magentaBliss.main}
              />
            </Box>
            <Typography fontWeight={600} color="blueGray700">
              {t("Conclusion.report_with_followup")}
            </Typography>
          </Stack>
        )}

        {(reportDetail?.status?.details?.causes?.length > 0 ||
          reportDetail?.status?.details?.causes?.length > 0) && (
          <>
            <Typography color="secondary" fontSize="body1" fontWeight={600}>
              {t("Conclusion.close_causes")}
            </Typography>
            <Stack marginBottom={2}>
              {reportDetail?.status?.details?.causes?.map((item, i) => (
                <Stack direction="row" alignItems="center" key={i}>
                  <Icon
                    name="bold_forbidden"
                    size={16}
                    color={theme.palette.red.main}
                    style={{ marginRight: 10 }}
                  />
                  <Typography fontSize={16}>
                    {t(`Conclusion.${item}`)}
                  </Typography>
                </Stack>
              ))}
              {reportDetail?.status?.details?.another_causes?.map((item, i) => (
                <Stack direction="row" alignItems="center" key={i}>
                  <Icon
                    name="bold_forbidden"
                    size={16}
                    color={theme.palette.red.main}
                    style={{ marginRight: 10 }}
                  />
                  <Typography fontSize={16}>{item}</Typography>
                </Stack>
              ))}
            </Stack>
          </>
        )}

        {reportDetail?.status?.details?.observations && (
          <>
            <Typography color="ethicsBlue" fontSize="body1" fontWeight={600}>
              {t("Conclusion.general_comments")}
            </Typography>
            <Typography
              fontSize={16}
              borderBottom={`1px solid ${theme.palette.blueGray200.main}`}
            >
              {reportDetail.status.details.observations}
            </Typography>
          </>
        )}
        <Box display="flex" justifyContent="flex-end" paddingTop={2}>
          <EGButton
            label={t("Conclusion.attachments")}
            onClick={() => setShowComplementsModal(true)}
            iconName="paperclip_2"
            disabled={reportDetail?.status?.details?.files?.length === 0}
            sx={{ width: "fit-content" }}
          />
        </Box>
      </Box>
    </>
  );
};
